import Cookies from 'js-cookie';
import apiSlice from './apiSlice';

const apiSliceWithTag = apiSlice.enhanceEndpoints({ addTagTypes: ['Answers'] });

const apiAnswersSlice = apiSliceWithTag.injectEndpoints({
  endpoints: (builder) => ({
    getAnswers: builder.query({
      query: ({ ean, Q, mine }) => ({
        url: `/community/products/${ean}/questions/${Q}/answers/`,
        params: {
          mine,
        },
      }),
      providesTags: ['Answers'],
    }),
    addNewAnswer: builder.mutation({
      query: ({ payload, ean, Q }) => ({
        url: `/community/products/${ean}/questions/${Q}/answers/`,
        method: 'POST',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['Answers'],
    }),
    updateAnswer: builder.mutation({
      query: ({ payload, ean, Q, id }) => ({
        url: `/community/products/${ean}/questions/${Q}/answers/${id}`,
        method: 'PUT',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['Answers'],
    }),
    deleteAnswer: builder.mutation({
      query: ({ ean, Q, id }) => ({
        url: `/community/products/${ean}/questions/${Q}/answers/${id}`,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['Answers'],
    }),
  }),
});

export const { useGetAnswersQuery, useAddNewAnswerMutation, useUpdateAnswerMutation, useDeleteAnswerMutation } = apiAnswersSlice;

export default apiAnswersSlice;
